import { useTranslation } from "react-i18next";
import styled from "styled-components";

type SupportMarket = {
  flag: string;
  email: string;
};

type SupportMarkets = {
  [key: string]: SupportMarket;
};

const support: SupportMarkets = {
  US: {
    flag: "🇺🇸",
    email: "support@jointacademy.com",
  },
  SE: {
    flag: "🇸🇪",
    email: "support@jointacademy.se",
  },
  GB: {
    flag: "🇬🇧",
    email: "support@jointacademy.co.uk",
  },
};

const SupportFooter = () => {
  const { i18n, t } = useTranslation();

  const locale = i18n.language.toUpperCase().split("-")[1];
  const validLocale = Object.keys(support).includes(locale);

  if (validLocale) {
    const { email } = support[locale];
    return (
      <StyledSupportFooter>
        {`${t("need-help1")} `}
        <StyledLink href={`mailto:${email}`}>{`${email} `}</StyledLink>
      </StyledSupportFooter>
    );
  } else {
    return (
      <StyledSupportFooter>
        {t("need-help1")}
        {Object.keys(support).map((key) => {
          const { email, flag } = support[key];
          return (
            <div key={key}>
              {`${flag} `}
              <StyledLink href={`mailto:${email}`}>{`${email} `}</StyledLink>
            </div>
          );
        })}
      </StyledSupportFooter>
    );
  }
};

export default SupportFooter;

const StyledSupportFooter = styled.div`
  font-size: 14px;
  font-weight: 300;
  color: rgb(56, 74, 95);
`;

const StyledLink = styled.a`
  color: rgb(56, 74, 95);
`;
